

import { defineComponent, PropType, ref, computed, unref, watch, onMounted, Slots } from 'vue'

/* NPM Plugins */
import { ElMessage, ElUpload, UploadFile } from 'element-plus';

/* Stores */
import { useAppStore } from '@/store/app'

/* Utils */
import { config } from '@/config/config'
import { propTypes } from '@/utils/propTypes';

/* Dtos */
import type { MaterialUploadDto } from '../../../apis/materials/material.dto';
import moment from 'moment';

export default defineComponent({
    Name: "FileUpload",
    components: { ElUpload },
    props: {
        relationId: propTypes.string.def(''),
        categoryId: propTypes.string.def(''),
        typeId: propTypes.string.def(''),
        typeDesc: propTypes.string.def('')
    },
    emits: ['onSuccess'],
    setup(props, { slots, expose, emit }) {

        const { base_url } = config

        const login = useAppStore().getLoginInfo

        const actionUrl = `${base_url}/api/sysmaterial/uploadfile`;

        const upHeaders = ref<Record<string, string>>({ "Authorization": `Bearer ${login.token}` })

        const uploadSchema = ref<MaterialUploadDto>({
            categroy_id: props.categoryId,
            ct_num: moment().format('YYYYMMDD'),
            material_type: props.typeId,
            material_type_desc: props.typeDesc,
            ct_id: props.relationId,
        })

        /* 上传成功 */
        const onUploadSuccess = (res: IResponse, file: UploadFile) => {

            if (!res.succeeded) {

                ElMessage.error(`文件上传失败，可能的原因是：${res.errors}`)

            } else {

                ElMessage.success("上传成功")

                emit('onSuccess', res.data)

            }
        };

        watch(() => props.relationId, (relId: string) => { 

            unref(uploadSchema).ct_id = relId

        }, { immediate: true, deep: true })

        return () => (
            <ElUpload action={unref(actionUrl)} headers={unref(upHeaders)} data={unref(uploadSchema)} show-file-list={false} limit={1} onSuccess={onUploadSuccess}>
                <el-button type="primary">上传文件</el-button>
            </ElUpload>
        )
    }
})


